import React from "react";
import { Col } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const BackButton = ({ path, title }) => {
  const navigate = useNavigate();

  return (
    <Col xs="auto m-0">
      <h5 className="text-primary d-flex gap-2 align-items-center mb-0 fs-10">
        <div className="icon-button" onClick={() => navigate(path)}>
          <ArrowLeft size={16} />
        </div>
        <span>{title}</span>
      </h5>
    </Col>
  );
};

export default BackButton;
